import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ActivityGridViewData } from '../types';

export abstract class ActivityGridBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<ActivityGridViewData> {
    throw new Error('Not implemented');
  }
}
